import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykmex5bwyz: FaireProductEntity = {
  token: "p_ykmex5bwyz",
  type: "product",
  name: "Grizzly Chews Honeyberry Gummies",
  brandToken: "b_na83mkfjze",
  brandName: "Grizzly Foods",
  imageUrl: "https://cdn.faire.com/fastly/dd07ee4aba619ee2691a39f065eca72864a98be602e730498cb09ef7c699f4e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4f8106a294f265f225b563105e57f4fe12436f19527e78fc59fe0ffd8e94ba4.jpeg",
    "https://cdn.faire.com/fastly/76112f503b1b45cf79c7c7edc241f13552ab0109708a5774c240479730911e57.png",
    "https://cdn.faire.com/fastly/0bb99b60676d9d43d15b6f8756e0144571b7eb56ca6000ca27e9bd3055d7800f.jpeg"
  ],
  priceDollars: 4.14,
  description: "Low sugar, plant based gummies! Grizzly Chews are prebiotic, antioxidant-rich and packed with fiber. We’ve emulated the honeyberry as best we can so you can take it on the go!\n\nUnlike conventional snacks and gummies that rely on artificial colors, flavors, preservatives, and added sugars, Grizzly Chews deliver real fruit, natural sweetness, and gut-friendly fiber (without any of the junk).\n\n**We’re happy to accommodate lower minimums for new partners — please contact us to discuss your order.",
  tags: [],
  msrpDollars: 6.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:09.177Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
